module.exports = __webpack_public_path__ + "img/tiyan.51eb7f12.png";